module.exports = __webpack_public_path__ + "static/img/newgoods.b234df2e.png";